export var getIntersectionData = function getIntersectionData(clientRect, root) {
  // NOTE: если рута нет, то рутом становится document (window)
  var rootData = {
    top: 0,
    bottom: window.innerHeight
  };
  if (root) {
    var _root$getBoundingClie = root.getBoundingClientRect(),
      top = _root$getBoundingClie.top,
      bottom = _root$getBoundingClie.bottom;
    // NOTE: у рута могут быть отступы, нам необходимо их учитывать для определения с какой стороны мы прилипли
    var _getComputedStyle = getComputedStyle(root),
      paddingBottom = _getComputedStyle.paddingBottom,
      paddingTop = _getComputedStyle.paddingTop,
      borderBottomWidth = _getComputedStyle.borderBottomWidth,
      borderTopWidth = _getComputedStyle.borderTopWidth;
    rootData.top = top + parseFloat(paddingTop) + parseFloat(borderTopWidth);
    rootData.bottom = bottom - parseFloat(paddingBottom) - parseFloat(borderBottomWidth);
  }

  // NOTE: округляем, чтобы избежать проблем с пиксельной сеткой
  var isStuckToTop = Math.floor(clientRect.top) <= rootData.top;
  var isStuckToBottom = Math.ceil(clientRect.bottom) >= rootData.bottom;
  var isIntersecting = isStuckToBottom || isStuckToTop;
  return {
    isStuckToBottom: isStuckToBottom,
    isStuckToTop: isStuckToTop,
    isIntersecting: isIntersecting
  };
};